import React, { useContext } from 'react';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _sortBy from 'lodash/sortBy';
import { ItemCartContext } from '../../CatalogItemCart.context';
import ModifierSetSelection from '../ModifierSetSelection/ModifierSetSelection';
import './ModifierSetSelections.css';
function ModifierSetSelections() {
  var _useContext = useContext(ItemCartContext),
    modifierListIds = _useContext.item.modifierSets,
    modifierLists = _useContext.modifierLists;
  var orderedModifierLists = _sortBy(_map(modifierListIds, function (modifierListId) {
    return _find(modifierLists, {
      _id: modifierListId
    });
  }), ['order']);
  return /*#__PURE__*/React.createElement("div", {
    className: "modifier-set-selections"
  }, _map(orderedModifierLists, function (_ref) {
    var modifierListId = _ref._id;
    return /*#__PURE__*/React.createElement(ModifierSetSelection, {
      key: modifierListId,
      modifierListId: modifierListId
    });
  }));
}
export default ModifierSetSelections;